import { sendMessageToFlutter } from "../bridge";
import { FlutterChannel } from "../enums/channel";

/**
 * Displays a banner ad in Flutter with the specified ad unit IDs
 */
export function displayBannerAd(
  adUnitIdAndroid: string,
  adUnitIdIos: string,
): void {
  sendMessageToFlutter(FlutterChannel.SHOW_BANNER_AD, {
    adUnitIdAndroid,
    adUnitIdIos,
  });
}

/**
 * Hides the currently displayed banner ad
 */
export function hideBannerAd(): void {
  sendMessageToFlutter(FlutterChannel.HIDE_BANNER_AD);
}
